import React from 'react';
import SiteA from './SiteA';
import HoldingPage from './HoldingPage';

const PALETTES = [
  ['#3a4a39', '#2d3a2c', '#f4f1e8', '#7a8470'], // mossy + bone (default)
  ['#4a5d44', '#23301f', '#efe9d9', '#94a08a'], // deeper sage + warm bone
  ['#5b6b4f', '#1f2a1c', '#ece5d0', '#a3ad94'], // dusty olive + linen
  ['#3d4a48', '#1f2a28', '#eee9df', '#7d8a85'], // slate-tea + parchment
];

const FONT_PAIRS = [
  {
    label: 'Cormorant + Inter',
    head: "'Cormorant Garamond', Georgia, serif",
    body: "'Inter', system-ui, sans-serif",
  },
  {
    label: 'Cormorant only',
    head: "'Cormorant Garamond', Georgia, serif",
    body: "'Cormorant Garamond', Georgia, serif",
  },
  {
    label: 'Georgia + system',
    head: "Georgia, 'Times New Roman', serif",
    body: 'system-ui, -apple-system, sans-serif',
  },
];

const TWEAK_DEFAULTS = {
  palette: PALETTES[0],
  fontHead: FONT_PAIRS[0].head,
  fontBody: FONT_PAIRS[0].body,
  hero: 'illust',
  density: 'cards',
};

export default function App() {
  const [tweaks] = React.useState(TWEAK_DEFAULTS);

  const adapted = React.useMemo(
    () => ({
      paletteA: tweaks.palette,
      fontHeadA: tweaks.fontHead,
      fontBodyA: tweaks.fontBody,
      heroA: tweaks.hero,
      density: tweaks.density,
    }),
    [tweaks]
  );

  if (import.meta.env.VITE_MAINTENANCE === 'true') return <HoldingPage />;
  return <SiteA tweaks={adapted} />;
}
